import React, { useMemo, useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";

import IconButton from "@cayuse/shared-react.components.icon-button";
import PaddedCell from "@cayuse/shared-react.components.padded-cell";

import FlowableForm from "components/flowable/FlowableForm";
import { addARIAGroupingAttributes, addARIARolesForTabs } from "components/FormResponse/hooks/useFormImproveA11y";
import { useDictionary } from "hooks";
import { tenantSelectors } from "store/selectors";
import { transformFetchedPreviewFormModel } from "utils";

import styles from "../SimplifiedBuilder/SimplifiedFormBuilderView.css";

export const ModelerPreview = ({ config, closePreview }) => {
	const [ formVariables, setFormVariables ] = useState({});
	const modelerPreviewWrapperRef = useRef(null);
	const isSimple = useSelector(tenantSelectors.tenant).simplifiedFormBuilderEnabled;
	const dictionary = useDictionary("formDesigner");

	const formConfig = useMemo(
		() => transformFetchedPreviewFormModel(config),
		[ config ]
	);

	useEffect(() => {
		if (modelerPreviewWrapperRef?.current) {
			addARIAGroupingAttributes(modelerPreviewWrapperRef.current);
			addARIARolesForTabs(modelerPreviewWrapperRef.current);
		}
	}, [ config, modelerPreviewWrapperRef ]);

	return (
		<>
			<PaddedCell className={`${styles.headerContainer} ${isSimple ? styles.simpleHC : styles.advancedHC}`}>
				<IconButton icon="times" onClick={closePreview} primary>
					{dictionary?.closePreview || "Close Preview"}
				</IconButton>
			</PaddedCell>
			<div ref={modelerPreviewWrapperRef}>
				<FlowableForm
					className={styles.modelerPreviewFormWrapper}
					debug={true}
					enabled={true}
					formConfig={formConfig}
					formVariables={{}}
					onChange={setFormVariables}
				/>
			</div>
		</>
	);
};
